import React from "react"
import {Header, Segment} from "semantic-ui-react"
import {FormattedMessage} from "react-intl"
import {LandingHeaderAboutGedcom} from "./landing-header-gedcom"
import {LandingHeaderOurStory} from "./landing-header-story"
import {LandingHeaderFamilyTime} from "./landing-header-family"
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"


const slider = {
    dots: true,
    arrows: true,
    fade: true,
    infinite: true,
    autoplay: false,
    autoplaySpeed: 5000,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    waitForAnimate: false,
    pauseOnHover: true,
    accessibility: true
}

export function LandingHeader() {
    return (
        <>
            <Header className="landing-header" textAlign="center" as="h1">
                <FormattedMessage id="landing.header.welcome"/>
                <p style={{ fontWeight: "bold" }}><FormattedMessage id="landing.header.easy"/></p>
            </Header>

            {/* Slider */}
            <Segment textAlign="center" className="landing-slider">
                <Slider {...slider}>
                    {/* OUR STORY */}
                    <LandingHeaderOurStory/>
                    {/* FAMILY TIME */}
                    <LandingHeaderFamilyTime/>
                    {/* ABOUT GEDCOM */}
                    <LandingHeaderAboutGedcom/>
                </Slider>
            </Segment>
        </>
    )
}